<template>
    <v-tooltip v-bind="tooltipProps">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                :href="href"
                target="_blank"
                v-bind="tooltip && attrs"
                v-on="tooltip && on"
                color="docButtonColor"
                style="color: var(--v-docButtonTextColor-base);"
                fab
                small
                depressed
            >
                <v-icon style="margin-left: 2px;">
                    mdi-file-document-outline
                </v-icon>
            </v-btn>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
export default {
    props: {
        href: {
            type: String,
            required: true,
        },
        tooltip: {
            type: String,
            default: '',
        },
        tooltipPos: {
            type: String,
            default: 'bottom',
        }
    },
    computed: {
        tooltipProps() {
            return { [`${this.tooltipPos}`]: true };
        },
    },
};
</script>
